export default (getView) => (nextStepPath) => ({
  ...getView(nextStepPath),
})
